import { Components, PaletteMode, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

export const MuiButtonBaseTheme = (mode: PaletteMode): Components<Theme>['MuiButtonBase'] => {
  const { componentTokens } = themePalette(mode);

  return {
    defaultProps: {
      disableRipple: true,
    },
    styleOverrides: {
      root: {
        cursor: 'pointer',
        color: componentTokens.buttons.colors.link.secondary.text.resting,
        textDecoration: 'none',
        backgroundColor: 'transparent',
        transition: 'all 0.2s linear',
      },
    },
  };
};
